module.exports = __webpack_public_path__ + "assets/img/rts_Logo.fe414cc2.png";